/**
 * Constantes para o painel administrativo
 * Centralizadas para facilitar manutenção e internacionalização
 */

// Configurações de paginação
export const APPOINTMENTS_PAGE_SIZE = 10;
export const THERAPISTS_LOAD_LIMIT = 100;
export const PATIENTS_LOAD_LIMIT = 100;

// Valores de filtros
export const FILTER_ALL_VALUE = "all";

// Labels de filtros
export const FILTER_LABELS = {
  START_DATE: "Data Inicial",
  END_DATE: "Data Final",
  STATUS: "Status",
  THERAPIST: "Terapeuta",
  PATIENT: "Paciente",
  MIN_PARTICIPANTS: "Mín. Participantes",
  MAX_PARTICIPANTS: "Máx. Participantes",
  CLEAR_FILTERS: "Limpar Filtros",
  ACTIVE_FILTERS: "Filtros Ativos"
} as const;

// Placeholders
export const FILTER_PLACEHOLDERS = {
  START_DATE: "Selecione a data inicial",
  END_DATE: "Selecione a data final",
  STATUS: "Todos os status",
  THERAPIST: "Selecione um terapeuta",
  PATIENT: "Selecione um paciente",
  MIN_PARTICIPANTS: "Mínimo",
  MAX_PARTICIPANTS: "Máximo",
  SEARCH: "Buscar..."
} as const;

// Status dos appointments
export const APPOINTMENT_STATUS = {
  ALL: "all",
  CONFIRMED: "confirmado",
  PENDING: "pendente",
  CANCELLED: "cancelado"
} as const;

// Labels dos status
export const APPOINTMENT_STATUS_LABELS = {
  [APPOINTMENT_STATUS.ALL]: "Todos os status",
  [APPOINTMENT_STATUS.CONFIRMED]: "Confirmado",
  [APPOINTMENT_STATUS.PENDING]: "Pendente",
  [APPOINTMENT_STATUS.CANCELLED]: "Cancelado"
} as const;

// Cores dos badges de status
export const APPOINTMENT_STATUS_COLORS = {
  [APPOINTMENT_STATUS.CONFIRMED]: "bg-green-100 text-green-800",
  [APPOINTMENT_STATUS.PENDING]: "bg-yellow-100 text-yellow-800",
  [APPOINTMENT_STATUS.CANCELLED]: "bg-red-100 text-red-800"
} as const;

// Labels das colunas da tabela
export const TABLE_HEADERS = {
  DATE: "Data/Hora",
  THERAPIST: "Terapeuta",
  PATIENT: "Paciente",
  PARTICIPANTS: "Participantes",
  STATUS: "Status",
  ACTIONS: "Ações"
} as const;

// Labels das estatísticas
export const STATS_LABELS = {
  TOTAL_APPOINTMENTS: "Total de Consultas",
  CONFIRMED_APPOINTMENTS: "Confirmadas",
  TOTAL_PARTICIPANTS: "Total Participantes",
  AVG_PARTICIPANTS: "Média Participantes"
} as const;

// Mensagens de UI
export const UI_MESSAGES = {
  LOADING: "Carregando...",
  LOADING_MORE: "Carregando mais...",
  NO_MORE_RESULTS: "Sem mais resultados",
  EMPTY_APPOINTMENTS: "Nenhuma consulta encontrada",
  EMPTY_APPOINTMENTS_SUBTITLE: "Tente ajustar os filtros para ver resultados",
  ERROR_LOADING: "Erro ao carregar consultas",
  ERROR_LOADING_STATS: "Erro ao carregar estatísticas",
  ERROR_LOADING_DETAILS: "Erro ao carregar detalhes",
  VIEW_DETAILS: "Ver detalhes",
  CLOSE: "Fechar"
} as const;

// Labels do modal de detalhes
export const MODAL_LABELS = {
  TITLE: "Detalhes da Consulta",
  BASIC_INFO: "Informações Básicas",
  PARTICIPANTS_INFO: "Participantes",
  DATE: "Data e Horário",
  STATUS: "Status",
  THERAPIST: "Terapeuta",
  PATIENT: "Paciente",
  PUBLIC: "Pública",
  PARTICIPANT_COUNT: "Número de Participantes",
  ROOM_LINK: "Link da Sala",
  YES: "Sim",
  NO: "Não",
  LOADING_PARTICIPANTS: "Carregando participantes...",
  NO_PARTICIPANTS: "Nenhum participante",
  GO_TO_ROOM: "Ir para sala"
} as const;

// Labels da aba
export const TAB_LABELS = {
  APPOINTMENTS_OVERVIEW: "Visão Geral de Consultas"
} as const;

// Formatos de data
export const DATE_FORMATS = {
  DISPLAY_FULL: "dd/MM/yyyy HH:mm",
  DISPLAY_SHORT: "dd/MM/yy HH:mm",
  INPUT: "yyyy-MM-dd"
} as const;
